import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import SearchMultiSelectInput from '../SearchMultiSelectInput/index.js';
import { genericMemo, rankedSearchOnList } from '../../utils/index.js';

// eslint-disable-next-line @typescript-eslint/ban-types
function MultiSelectInput(props) {
  const {
    options,
    ...otherProps
  } = props;
  return /*#__PURE__*/React.createElement(SearchMultiSelectInput, _extends({}, otherProps, {
    options: options,
    sortFunction: rankedSearchOnList,
    searchOptions: options
  }));
}

var index = genericMemo(MultiSelectInput);

export { index as default };
//# sourceMappingURL=index.js.map
